import 'babel-polyfill'
import Promise from 'es6-promise'
import 'ie-placeholder'
import './assets/js/utils/rem'
import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import service from './assets/js/utils/axiosConfig.js'
import './permission' // permission control
import './assets/css/index.scss'
import animate from 'animate.css'
import VueAnimateNumber from 'vue-animate-number'
// 引入百度地图
import BaiduMap from 'vue-baidu-map'
// 图片懒加载
import vueLazy from 'vue-lazyload'

Vue.use(BaiduMap, {
  ak: 'jwGOk0NgfUkWLh27jp5MHoCuqtaCVCT8'
})
Vue.use(VueAnimateNumber)
Vue.use(animate)
Promise.polyfill() // global css
Vue.use(ElementUI)

var userAgent = window.navigator.userAgent
if (userAgent.indexOf('NET') !== -1) {
  // ie浏览器不兼容懒加载组件处理
  Vue.directive('lazy', function (el, binding) {
    el.src = binding.value
  })
} else {
  // 实现图片懒加载
  Vue.use(vueLazy, {
    preLoad: 3,
    attempt: 3,
    loading: require('@/assets/img/loading.gif'),
    error: require('@/assets/img/five.png')
  })
}

Vue.config.productionTip = false
Vue.prototype.$http = service
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
